import PropTypes from 'prop-types';
import React from 'react';
import { deprecate } from 'react-is-deprecated';
import clsx from 'clsx';
import { useReaxlConfiguration } from '../reaxl-configuration.js';
import PartnerLink from '../PartnerLink/index.js';
import { jsx as _jsx } from "react/jsx-runtime";
function defaultLinkRenderer(linkProps) {
  // anchor content is supplied by props.children
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return /*#__PURE__*/_jsx("a", {
    ...linkProps
  });
}
function Link(props) {
  const {
    children,
    className,
    label,
    external = false,
    undecorated = false,
    inverse = false,
    partner,
    ...rest
  } = props;
  const {
    linkRenderer = defaultLinkRenderer
  } = useReaxlConfiguration();

  // Deprecated Partner Link attribute
  if (partner) {
    return /*#__PURE__*/_jsx(PartnerLink, {
      ...props
    });
  }
  const linkProps = {
    'data-cmp': 'link',
    children: label || children,
    className: clsx(className, {
      'link-undecorated': undecorated,
      inverted: inverse
    }) || undefined,
    // fallback undefined to remove className if it empty.
    ...(rest.href && typeof rest.onClick === 'function' && !rest.onContextMenu && {
      onContextMenu: rest.onClick
    }),
    // external is deprecated. These values should be passed in based on need
    ...(external && {
      target: '_blank',
      rel: 'nofollow noopener'
    }),
    ...rest
  };
  return linkRenderer(linkProps);
}
export default Link;